"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleReplacement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const ToggleReplacement_styles_1 = require("./ToggleReplacement.styles");
function ToggleReplacement({ item, replacementItem, active, size = 'Small', onUpdate, }) {
    var _a, _b;
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const theme = (0, styled_components_1.useTheme)();
    const [isToggled, setIsToggled] = (0, react_1.useState)(active);
    const handleToggle = (0, react_1.useCallback)(() => {
        setIsToggled((prev) => !prev);
        onUpdate({
            action: isToggled ? replacementItem.action : item.action,
            data: isToggled ? replacementItem : item,
        });
    }, [isToggled, item, onUpdate, replacementItem]);
    const title = t(isToggled ? replacementItem.titleKey : item.titleKey);
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.Tooltip, { text: title, visible: !!title, children: (0, jsx_runtime_1.jsx)(ToggleReplacement_styles_1.StyledToggle, { title: title, size: size, onClick: handleToggle, active: isToggled, disabled: false, children: (0, jsx_runtime_1.jsx)(ToggleReplacement_styles_1.StyledToggleReplacementIcon, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: (isToggled ? (_a = replacementItem.icon) === null || _a === void 0 ? void 0 : _a.name : (_b = item.icon) === null || _b === void 0 ? void 0 : _b.name) || '', size: size, color: isToggled ? theme.Color.System.Primary : theme.Color.Neutrals.Dark }) }) }) }));
}
exports.ToggleReplacement = ToggleReplacement;
//# sourceMappingURL=ToggleReplacement.js.map